module.exports = __webpack_public_path__ + "img/23.f816deab.jpg";